import { Request } from '@/classes/Request.ts'

export interface EnrollmentRequestCodeResponse {
  success: boolean
  data?: {
    code_sent?: boolean
    already_pending?: boolean
    already_verified?: boolean
    email?: string
    // Envy/dev only: the backend surfaces the plaintext code so testers can proceed
    // without a real inbox. Never present in production.
    dev_code?: string
  }
  failure_reason?: string
}

/**
 * Email a one-time verification code to the invitee (email-ownership check
 * before the enrollment form). Token-authenticated, public.
 *
 * Auto-send on mount leaves `resend` false: the backend is idempotent within the
 * code TTL, so a page refresh won't invalidate the code already in the inbox.
 * The "Resend" button passes resend=true to force a fresh code.
 * POST /api/enrollment/invitation/{token}/request-code
 */
export const enrollmentRequestCode = async (
  token: string,
  resend = false
): Promise<EnrollmentRequestCodeResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/request-code`,
    { resend }
  )
  return response.data
}
